import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Radio } from '@components/core-ui/form-elements/Radio';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { Tooltip } from '@components/core-ui/Tooltip';
import { useAuthContext } from '@providers/AuthProvider';
import { useAPI } from '@providers/useAPI';
import { JobResponseDto, JobsService } from 'app/API';
import { useState } from 'react';
import { Content } from './styles/Content';

type TProps = {
  job: JobResponseDto;
  onCancel: () => void;
  onSuccess: () => void;
};

export const MoveJobToWSModal = ({ job, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { workspace, organization } = useAuthContext();
  const workspaceId = job.workspaceId ?? workspace?.id ?? '';
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(workspaceId);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await call(
      JobsService.moveJobToWs({
        wsid: workspaceId,
        jobId: job.id,
        requestBody: { workspaceId: selectedWorkspaceId ?? '' },
      }),
    );
    setIsSubmitting(false);
    onSuccess();
    onCancel();
  };

  return (
    <ModalWrapper width="487px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Move Job to another workspace</ModalTitle>
      <Content>
        <TableWrapper className="customTable">
          <Table>
            <Thead $white>
              <Tr>
                <Th>Workspace Name</Th>
              </Tr>
            </Thead>
            <Tbody>
              {(organization?.workspaces ?? []).map((data) => {
                const disabled = workspaceId === data.id || !organization?.permissions?.submitJobs;
                const disabledInfo =
                  workspaceId === data.id
                    ? 'Cannot move the job to the same Workspace'
                    : `You don't have "Submit Jobs" permission on this Workspace`;
                return (
                  <Tr key={data.id}>
                    <Td>
                      {disabled ? (
                        <Tooltip content={disabledInfo} placement="bottom">
                          <div className="radioWrapper disabled">
                            <Radio onChange={() => {}} checked={selectedWorkspaceId === data.id} disabled={true}>
                              {data?.name}
                            </Radio>
                          </div>
                        </Tooltip>
                      ) : (
                        <div className="radioWrapper">
                          <Radio
                            onChange={() => setSelectedWorkspaceId(data.id)}
                            checked={selectedWorkspaceId === data.id}
                          >
                            {data?.name}
                          </Radio>
                        </div>
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableWrapper>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button disabled={selectedWorkspaceId === workspaceId} onClick={handleSubmit}>
            Move
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
